// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface SchematisationReference
 */
export interface SchematisationReference {
  /**
   *
   */
  id: string;
  /**
   *
   */
  lastModified: Date;
  /**
   *
   */
  descriptorId: string;
  /**
   *
   */
  ref: string;
  /**
   *
   */
  schematisationId: number;
  /**
   *
   */
  revisionId?: number | null;
}

/**
 * Check if a given object implements the SchematisationReference interface.
 */
export function instanceOfSchematisationReference(value: object): value is SchematisationReference {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("lastModified" in (value as Record<string, any>)) &&
      !("last_modified" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lastModified"] === undefined &&
      (value as Record<string, any>)["last_modified"] === undefined)
  )
    return false;
  if (
    (!("descriptorId" in (value as Record<string, any>)) &&
      !("descriptor_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["descriptorId"] === undefined &&
      (value as Record<string, any>)["descriptor_id"] === undefined)
  )
    return false;
  if (!("ref" in value) || value["ref"] === undefined) return false;
  if (
    (!("schematisationId" in (value as Record<string, any>)) &&
      !("schematisation_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["schematisationId"] === undefined &&
      (value as Record<string, any>)["schematisation_id"] === undefined)
  )
    return false;
  return true;
}

export function SchematisationReferenceFromJSON(json: any): SchematisationReference {
  return SchematisationReferenceFromJSONTyped(json, false);
}

export function SchematisationReferenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SchematisationReference {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    lastModified:
      json["last_modified"] == null ? json["last_modified"] : parseDateTime(json["last_modified"]),
    descriptorId: json["descriptor_id"],
    ref: json["ref"],
    schematisationId: json["schematisation_id"],
    revisionId:
      json["revision_id"] === undefined
        ? undefined
        : json["revision_id"] === null
        ? null
        : json["revision_id"],
  };
}

export function SchematisationReferenceToJSON(json: any): SchematisationReference {
  return SchematisationReferenceToJSONTyped(json, false);
}

export function SchematisationReferenceToJSONTyped(
  value?: SchematisationReference | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    last_modified:
      value["lastModified"] == null
        ? value["lastModified"]
        : serializeDateTime(value["lastModified"]),
    descriptor_id: value["descriptorId"],
    ref: value["ref"],
    schematisation_id: value["schematisationId"],
    revision_id: value["revisionId"],
  };
}
